import { supabase } from './supabase'
import type { User } from '../lib/supabase'

export async function getUsers() {
  const { data, error } = await supabase
    .from('user_profiles')
    .select('*')
    .order('created_at', { ascending: true })

  if (error) throw error
  return data as User[]
}

export async function createUser(email: string, username: string, displayName?: string) {
  // 1. 通过 Supabase Auth 创建用户
  const { data: authData, error: authError } = await supabase.auth.admin.createUser({
    email,
    password: Math.random().toString(36).slice(-8), // 临时密码
    email_confirm: true,
    user_metadata: { username, display_name: displayName },
  })

  if (authError) throw authError

  // 2. 创建用户档案（角色默认为 viewer）
  const { error: profileError } = await supabase.from('user_profiles').insert({
    id: authData.user.id,
    email,
    username,
    role: 'viewer',
    display_name: displayName,
  })

  if (profileError) throw profileError

  return authData.user
}

export async function deleteUser(userId: string) {
  const { error } = await supabase.auth.admin.deleteUser(userId)
  if (error) throw error
}

export async function updateUserRole(userId: string, role: 'admin' | 'viewer') {
  const { error } = await supabase
    .from('user_profiles')
    .update({ role })
    .eq('id', userId)

  if (error) throw error
}
